import { render, staticRenderFns } from "./VectorizationManagementRegister.vue?vue&type=template&id=6bb5ed84"
import script from "./VectorizationManagementRegister.vue?vue&type=script&lang=js"
export * from "./VectorizationManagementRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports